import { ACCOUNT_WALLET_PATH } from "@/pages/dashboard/config/routes";

export function getTransactionDetailsPath(offer) {
  return !offer.last_instant_payment
    ? `${ACCOUNT_WALLET_PATH}/${offer.id}/details_offer`
    : `${ACCOUNT_WALLET_PATH}/${offer.last_instant_payment.id}/details_instant_payment`;
}
